import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';


@Component({
    selector: 'app-select-printer',
    templateUrl: './select-printer.component.html',
    styleUrls: ['./select-printer.component.scss'],
})
export class SelectPrinterComponent {

    @Input() printers: any[] = [];

    constructor(private modalCtrl: ModalController) { }

    select(printer: any) {
        this.modalCtrl.dismiss(printer);
    }

    cancel() {
        this.modalCtrl.dismiss(null);
    }

}
